module.exports = __webpack_public_path__ + "img/Choripapas.6794f79b.jpeg";